// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// CustomEvent Polyfill Module

// Define CustomEvent on platforms that do not support it

define('CustomEventPolyFill',['require'],function (require) {
    'use strict';

    // Constructor
    function CustomEventPolyFill () {
        var CustomEvent = function(event, params) {
            // Parameters
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            // Create the new event type and initialize
            var customEvent = document.createEvent('CustomEvent');
            customEvent.initCustomEvent(event,
                                        params.bubbles,
                                        params.cancelable,
                                        params.detail);
            return customEvent;
        };
        // Inherit Event prototypes
        CustomEvent.prototype = window.Event.prototype;
        // Add to global scope
        window.CustomEvent = CustomEvent;
    };

    // Return Constructor
    return CustomEventPolyFill.prototype.constructor;
});

